import { Html } from '@react-three/drei'
import { paraArray, type Vetor3 } from '../../dominio/geometria/vetor3'
import { useRotulosCenaVisiveis } from './contextoMaquete'

interface Props {
  posicao: Vetor3 | [number, number, number]
  texto: string
  subtexto?: string
  variante?: 'neutro' | 'estrutura' | 'zona' | 'srs' | 'retencao' | 'trajetoria' | 'risco' | 'eixo' | 'achado'
  fator?: number
  /** Ignora o interruptor de rótulos — para ferramentas de depuração ligadas de propósito. */
  sempreVisivel?: boolean
  /**
   * Tamanho fixo na tela, como um chip: não cresce quando a câmera chega perto
   * (com `fator`, de perto o rótulo cobria justamente a peça que se queria tocar).
   */
  tamanhoFixo?: boolean
}

/**
 * Rótulo curto ancorado em um ponto da cena.
 *
 * Usa HTML sobreposto em vez de texto em malha: o rótulo fica sempre legível,
 * não exige carregar fonte para o WebGL e acompanha o zoom.
 *
 * Só aparece com "rótulos na cena" ligado (painel de Camadas): espalhados pelo
 * veículo, os chips cobriam justamente o que o aluno precisava ver.
 */
export function Rotulo3D({ posicao, texto, subtexto, variante = 'neutro', fator = 7, sempreVisivel = false, tamanhoFixo = false }: Props) {
  const visiveis = useRotulosCenaVisiveis()
  if (!visiveis && !sempreVisivel) return null
  const p = Array.isArray(posicao) ? posicao : paraArray(posicao)
  return (
    <Html position={p} center distanceFactor={tamanhoFixo ? undefined : fator} style={{ pointerEvents: 'none' }} zIndexRange={[8, 0]}>
      <div className={`rotulo-3d ${variante}${tamanhoFixo ? ' rotulo-3d--chip' : ''}`}>
        {texto}
        {subtexto && <small>{subtexto}</small>}
      </div>
    </Html>
  )
}
